import React, { ReactNode } from "react";
import ModalCommon from "components/ModalCommon";
import * as S from "./styles";
import MaterialUI from "../../../../material-UI";

interface ModalCommonConfirmProps {
  /** URL (ou caminho) da imagem/ícone */
  icon: () => JSX.Element;
  /** Texto exibido na modal */
  message: string;
  /** Se a modal está aberta ou fechada */
  open: boolean;
  /** Setter para controle de abertura/fechamento (ex: setState) */
  setOpen: (value: boolean) => void;
  /** Função chamada ao clicar em "Confirmar" */
  onConfirm: () => void;
  /** Função chamada ao clicar em "Cancelar" */
  onCancel: () => void;
  /** Texto do botão de confirmar (padrão: "Sim") */
  confirmLabel?: string;
  /** Texto do botão de cancelar (padrão: "Cancelar") */
  cancelLabel?: string;
  isLoading?: boolean;
}

const ModalCommonConfirm: React.FC<ModalCommonConfirmProps> = ({
  icon,
  message,
  open,
  setOpen,
  onConfirm,
  onCancel,
  confirmLabel = "Sim",
  cancelLabel = "Cancelar",
  isLoading = false,
}) => {
  // Fecha a modal quando clicar no "x" ou fundo
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ModalCommon open={open} onClose={handleClose} setOpenModal={setOpen}>
      <S.Content>
        <S.Header>
          <S.IconContainer>{icon()}</S.IconContainer>
          <S.SpaceY space={12} />
          <S.MessageText>{message}</S.MessageText>
        </S.Header>

        <S.Footer>
          <S.CancelButton onClick={onCancel}>{cancelLabel}</S.CancelButton>
          <S.ConfirmButton onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <MaterialUI.CircularProgress size={20} color="inherit" />
            ) : (
              confirmLabel
            )}
          </S.ConfirmButton>
        </S.Footer>
      </S.Content>
    </ModalCommon>
  );
};

export default ModalCommonConfirm;
